import { render, staticRenderFns } from "./RecordVideoDialog.vue?vue&type=template&id=c730167e&scoped=true"
import script from "./RecordVideoDialog.vue?vue&type=script&lang=js"
export * from "./RecordVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordVideoDialog.vue?vue&type=style&index=0&id=c730167e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c730167e",
  null
  
)

export default component.exports